<!-- Modal Overlay -->
<div class="modal-backdrop fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50"
     (click)="onOverlayClick($event)">

  <!-- Modal Content -->
  <div class="relative w-full max-w-sm bg-white dark:bg-secondary-800 rounded-xl shadow-2xl border border-gray-200 dark:border-gray-700 flex flex-col mx-4"
       (click)="$event.stopPropagation()">

    <!-- Close button -->
    <button (click)="closeModal()"
            class="absolute top-4 right-4 z-10 p-1.5 rounded-lg text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-secondary-700 transition-colors">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5">
        <path d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
      </svg>
    </button>

    <!-- Header -->
    <div class="px-6 pt-5 pb-3">
      <h3 class="text-base font-medium text-gray-900 dark:text-white">Select Workspace</h3>
      <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">Choose a workspace for this report.</p>
    </div>

    <!-- Error State -->
    <div *ngIf="error$ | async as error" class="mx-6 mb-2 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-3">
      <p class="text-red-600 dark:text-red-400 text-sm">{{ error }}</p>
    </div>

    <!-- Loading -->
    <div *ngIf="loading$ | async" class="flex justify-center items-center py-10">
      <svg class="animate-spin h-5 w-5 text-blue-royal" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
    </div>

    <!-- Workspace list -->
    <div *ngIf="!(loading$ | async)" class="px-6 pb-2 max-h-60 overflow-y-auto space-y-1">
      <div *ngFor="let workspace of workspaces$ | async"
           (click)="selectWorkspace(workspace)"
           class="flex items-center gap-3 px-3 py-2 rounded-lg cursor-pointer transition-colors"
           [class]="selectedWorkspace?.id === workspace.id
             ? 'bg-primary/10'
             : 'hover:bg-primary/5'">
        <!-- Radio indicator -->
        <div class="flex-shrink-0 w-4 h-4 rounded-full border-2 flex items-center justify-center transition-colors"
             [class]="selectedWorkspace?.id === workspace.id
               ? 'border-primary'
               : 'border-gray-300 dark:border-gray-500'">
          <div *ngIf="selectedWorkspace?.id === workspace.id" class="w-2 h-2 rounded-full bg-primary"></div>
        </div>
        <!-- Workspace info -->
        <span class="text-sm text-gray-900 dark:text-white truncate">{{ workspace.name }}</span>
      </div>

      <!-- Empty State -->
      <div *ngIf="(workspaces$ | async)?.length === 0" class="flex items-center justify-center h-full">
        <p class="text-sm text-gray-500 dark:text-gray-400">No workspaces available</p>
      </div>
    </div>

    <!-- Validation error -->
    <div *ngIf="validationError"
         class="mx-6 mb-2 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-3"
         role="alert"
         aria-live="polite">
      <p class="text-red-600 dark:text-red-400 text-sm">{{ validationError }}</p>
    </div>

    <!-- Footer -->
    <div class="px-6 py-4 flex justify-end gap-3 border-t border-gray-100 dark:border-gray-700">
      <button type="button" (click)="closeModal()" class="btn btn-cancel">
        <span>Cancel</span>
      </button>
      <button type="button"
              (click)="generateReport()"
              [disabled]="!selectedWorkspace"
              class="btn btn-blue disabled:opacity-50 disabled:cursor-not-allowed">
        <span>Generate Report</span>
      </button>
    </div>
  </div>
</div>
